import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

window.initPlyr = function a(videoEl) {
  return new Plyr(videoEl, {
    iconUrl: '/play-icon.svg',
  })
}